'use client'
import React, { useEffect, useRef, useState } from 'react'
import { useLazyQuery } from '@apollo/client'

import { getXaxis, renderNewCords } from '@/shared/utils'
import { getRun } from '@/shared/constants'
import noDataImg from '@/assets/images/error-images/results.svg'
import { GET_WAGON_WHEEL_DATA } from '@/graphql/match/match.query'

// components
import ChartFilter from '../chartFilter'
import WagonWheelChart from '../wagonWheelChart'
import NoData from '../../noData'
import Loading from '../../loading'
import PlayerListChart from '../playerList'

function WagonWheel({ matchDetail, inningData }: any) {
  // ******** CONSTANTS ********
  const { aInning, oTeamScoreA, oTeamScoreB } = matchDetail || {}
  const teamAId = aInning?.[0]?.iBattingTeamId
  const teamA = teamAId === oTeamScoreA?.oTeam?._id ? oTeamScoreA?.oTeam : oTeamScoreB?.oTeam
  const teamB = teamA?._id === oTeamScoreA?.oTeam?._id ? oTeamScoreB?.oTeam : oTeamScoreA?.oTeam
  const allData = useRef<any>([])

  const [currentTeamId, setCurrentTeamId] = useState(teamA?._id)
  const [innNumber, setInnNumber] = useState(1)
  const [runs, setRuns] = useState<any>()
  const [playerData, setPlayerData] = useState(
    inningData?.find((i: any) => i?.iBattingTeamId === teamA?._id)
  )
  const [newData, setNewData] = useState([])
  const [typeWiseRun, setTypeWiseRun] = useState<any>({})
  const [isData, setIsData] = useState(false)

  useEffect(() => {
    getWagonWheelData({
      variables: {
        input: {
          iMatchId: matchDetail?._id,
          nInningNumber: 1
        }
      }
    })
  }, [])

  // ******************* GRAPHQL *******************

  //? INPUT { !MATCH_ID , INNING_NUMBER, BATTERS, BOWLERS}
  const [getWagonWheelData, { loading }] = useLazyQuery(GET_WAGON_WHEEL_DATA, {
    onCompleted: d => {
      const { runs: data, isCoordinate } = d?.getWagonsData || {}
      if (!runs?.total && runs?.total !== 0) {
        setIsData(!!isCoordinate)
        handleData(data)
      } else {
        handleData(data)
      }
    }
  })

  // ******************* FUNCTIONS *******************

  // !HANDLE DATA TYPE WISE
  function handleData(d: any) {
    const getTypeCount = (type: string) => d?.types?.find((t: any) => t?.type === type)?.count || 0

    const filterData = {
      '1s': getTypeCount('1s'),
      '2s': getTypeCount('2s'),
      '3s': getTypeCount('3s'),
      '4s': getTypeCount('4s'),
      '6s': getTypeCount('6s')
    }

    setTypeWiseRun(filterData)

    const { offSide, onSide, total } = d || {}
    setRuns({ offSide, onSide, total })

    const t = mapNewData(d?.types)
    setNewData(t)
    allData.current = t
  }

  // !CHANGE X AND Y CORDS AS PER ENTITY CORDS
  function mapNewData(d: any) {
    const t = d?.map((d: any) => {
      return {
        ...d,
        list: d?.list
          ?.map((t: any) => {
            const newCords = renderNewCords(getXaxis(t?.nXcord, getRun[d?.type]), t?.nYcord)
            return {
              x: newCords?.x,
              y: newCords?.y
            }
          })
          .filter((t: any) => t.x !== 0 || t.y !== 0)
      }
    })
    return t
  }

  // !TEAM CHANGE
  function handleTeam(id: string, ing: number) {
    const inningNumber = ing
    if (ing) setInnNumber(ing)
    if (inningNumber !== null) {
      getWagonWheelData({
        variables: {
          input: {
            iMatchId: matchDetail?._id,
            nInningNumber: inningNumber
          }
        }
      })
    }
    setCurrentTeamId(id)
    const t = inningData?.find((i: any) => i?.iBattingTeamId === id)
    setPlayerData(t)
  }

  // !FILTER DATA WITH BATTERS AND BOWLERS
  function handlePlayersData(batter: any, bowler: any) {
    const inningNumber =
      currentTeamId === teamA?._id
        ? batter?.length === 0
          ? 0
          : 1
        : currentTeamId === teamB?._id
          ? batter?.length === 0
            ? 0
            : 2
          : null
    if (batter?.length === 0 || inningNumber === 0) {
      setNewData([])
      setRuns({ onSide: 0, offSide: 0, total: 0 })
    }
    if (inningNumber !== null && inningNumber !== 0 && batter?.length > 0) {
      getWagonWheelData({
        variables: {
          input: {
            iMatchId: matchDetail?._id,
            nInningNumber: inningNumber,
            iBatterIds: batter,
            iBowlerId: bowler
          }
        }
      })
    }
  }

  function handleInning(d: any) {
    handleTeam(d?.iBattingTeamId, d?.nInningNumber)
  }

  return (
    <div className="container !p-0">
      {!runs?.total && runs?.total !== 0 && loading ? (
        <Loading />
      ) : isData ? (
        <>
          <div className=" md:bg-cardBg md:border border-tabBorder w-full pb-2 md:px-2 rounded-xl overflow-hiddeng my-2">
            {/* NAVBAR */}
            {/* <div className='flex justify-center gap-4'>
              <div
                className={`${
                  currentTeamId === teamA?._id ? 'bg-primary text-black cursor-default' : 'bg-theme text-white cursor-pointer'
                } text-center select-none px-3.5 py-2.5 rounded-s-3xl rounded-e-3xl  w-fit border text-base font-bold border-c hover:!bg-primary hover:text-black`}
                onClick={() => handleTeam(teamA?._id , 1)}
              >
                <span className='hidden md:block'> {teamA?.sTitle}</span>
                <span className='md:hidden block'> {teamA?.sAbbr}</span>
              </div>
              <div
                className={`${
                  currentTeamId === teamB?._id ? 'bg-primary text-black cursor-default' : 'bg-theme text-white cursor-pointer'
                } text-center text-sx md:text-base select-none px-3.5 py-2.5 rounded-s-3xl rounded-e-3xl  w-fit border text-base font-bold border-c hover:!bg-primary hover:text-black`}
                onClick={() => handleTeam(teamB?._id , 2)}
              >
                <span className='hidden md:block'> {teamB?.sTitle}</span>
                <span className='md:hidden block'> {teamB?.sAbbr}</span>
              </div>
            </div> */}
            <div
              className={`flex pt-2 pb-4 md:p-4 md:-mx-2 relative md:bg-headersActive rounded-t-xl border-b border-tabBorder gap-4 justify-center flex-nowrap whitespace-nowrap overflow-auto`}
            >
              {matchDetail?.aInning?.map((data: any, i: number) => {
                return (
                  <div
                    key={`${data?.sShortName}-${i}`}
                    className={`${
                      innNumber !== data?.nInningNumber
                        ? 'bg-theme text-textDselected cursor-pointer font-medium'
                        : 'bg-buttonBg !border-buttonBg font-bold dark:text-[#CED2D5] text-white cursor-default'
                    } text-center select-none px-4 py-1 rounded-lg w-fit border text-xs md:text-base  border-c `}
                    onClick={() => handleInning(data)}
                  >
                    {data?.sShortName}
                  </div>
                )
              })}
            </div>

            {/*RUNS MOBILE*/}
            <div className="flex md:hidden justify-center gap-4 items-center mt-4 md:bg-transparent py-4 bg-card-600 border-y rounded-lg border-card-700 w-full">
              <div className="flex items-baseline gap-2 text-start">
                <p className="text-t-note text-sm font-semibold">Off Side</p>
                <p className="text-lg">
                  {runs?.offSide}
                  <span className="mx-1 text-sm">runs</span>
                </p>
              </div>
              <div className="h-10 block w-[2px] bg-card-700"></div>
              <div className="flex items-baseline gap-2 text-start">
                <p className="text-t-note text-sm font-semibold">On Side</p>
                <p className="text-lg">
                  {runs?.onSide}
                  <span className="mx-1 text-sm">runs</span>
                </p>
              </div>
            </div>

            <div className="flex w-full justify-center md:justify-between items-center">
              <div className="text-start hidden md:flex flex-col min-w-14 ml-8">
                <p className="text-textDselected text-lg">Off Side</p>
                <p className="text-3xl text-textOffWhite">
                  {runs?.offSide}
                  <span className="mx-1 text-lg">runs</span>
                </p>
              </div>

              {/* WAGON WHEEL */}
              {loading ? (
                <div className="min-h-[440px] min-w-[440px] flex justify-center">
                  <Loading className={'!bg-card'} />
                </div>
              ) : (
                <WagonWheelChart data={newData} />
              )}

              <div className="text-start hidden md:flex flex-col min-w-14 mr-8">
                <p className="text-textDselected text-lg">On Side</p>
                <p className="text-3xl text-textOffWhite">
                  {runs?.onSide}
                  <span className="mx-1 text-lg">runs</span>
                </p>
              </div>
            </div>

            {/* RUN FILTER */}
            <ChartFilter
              currentTeamId={currentTeamId}
              allData={allData?.current}
              setNewData={setNewData}
              typeWiseRun={typeWiseRun}
              runs={runs}
            />
          </div>

          {/* PLAYER FILTER */}
          <PlayerListChart
            matchDetail={matchDetail}
            playerData={playerData}
            currentTeamId={currentTeamId}
            handlePlayersData={handlePlayersData}
          />
        </>
      ) : (
        <NoData
          imagePath={noDataImg}
          title="The wagon’s parked for now, but don’t worry – those big shots are just around the corner!"
        />
      )}
    </div>
  )
}

export default WagonWheel
